module.exports = __webpack_public_path__ + "static/neon@1.5x-cafbfb0ea0a2aacc71ca069f24f762f4.png";